import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import globalVariables from "GlobalVariable";
import { 
  Facebook, 
  Instagram, 
  Twitter, 
  Linkedin, 
  MessageCircle, 
  Phone, 
  ChevronDown, 
  ChevronRight, 
  User,
  Menu,
  X
} from 'lucide-react';

// Componente principal del Header
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50); // Se oculta después de 50px de scroll
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Cerrar menú móvil al cambiar de tamaño de pantalla
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Prevenir scroll del body cuando el menú móvil está abierto
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  return (
    <div className="w-full bg-white sticky top-0 z-40">
      {/* Barra superior roja - se oculta al hacer scroll y en móviles */}
      <div className={`bg-red-600 text-white py-2 transition-all duration-300 ease-in-out ${
        isScrolled ? 'hidden' : 'block'
      } hidden lg:block`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            {/* Redes sociales */}
            <div className="flex items-center space-x-3">
              <a href="#" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors p-2">
                <Facebook size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors p-2">
                <Instagram size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors p-2">
                <Twitter size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors p-2">
                <Linkedin size={20} />
              </a>
            </div>

            {/* Información de contacto y opciones */}
            <div className="flex items-center space-x-6 text-sm">
              <div className="flex items-center space-x-2">
                <MessageCircle size={16} />
                <span>info@azucarmultimedia.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} />
                <span>+1-408-509-0579</span>
              </div>
              <div className="flex items-center space-x-2 border-l border-r border-white/30 px-4">
                <span className="font-bold">EN</span>
                <span className="text-white/70">ES</span>
              </div>
              <div className="flex items-center space-x-4">
                <Link
                  to="/login"
                  className="text-white hover:text-gray-200 transition-colors font-medium"
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="bg-gray-800 text-white font-medium px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
                >
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Barra de navegación principal */}
      <div className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo ¡AZUCAR! */}
            <div className="flex items-center">
              <a href="/" className="flex items-center">
                <img 
                  src="https://samedaypet.s3.amazonaws.com/ba4faeb5-cc14-4e69-8846-204001c9f41f.png" 
                  alt="¡AZUCAR!" 
                  className="h-8 md:h-12 w-auto"
                />
              </a>
            </div>

            {/* Navegación Desktop */}
            <nav className="hidden lg:flex items-center space-x-8">
              <a href="#" className="text-gray-800 font-semibold hover:text-red-600 transition-colors">
                HOME
              </a>
              <a href="#" className="text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center space-x-1">
                <span>WHO WE HELP</span>
                <ChevronDown size={12} />
              </a>
              <a href="#" className="text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center space-x-1">
                <span>PLANS</span>
                <ChevronDown size={12} />
              </a>
              <a href="#" className="text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center space-x-1">
                <span>SERVICES</span>
                <ChevronDown size={12} />
              </a>
              <a href="#" className="text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center space-x-1">
                <span>COMPANY</span>
                <ChevronDown size={12} />
              </a>
              <a href="#" className="text-gray-800 font-semibold hover:text-red-600 transition-colors">
                BLOG
              </a>
              <a href="#" className="text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center space-x-1">
                <span>CONTACT</span>
                <ChevronDown size={12} />
              </a>
            </nav>

            {/* Botón CTA Desktop */}
            <div className="hidden md:flex items-center">
              <button className="bg-red-600 text-white px-4 md:px-6 py-2 md:py-3 rounded-md font-semibold hover:bg-red-700 transition-colors flex items-center space-x-2 text-sm md:text-base">
                <span>GET STARTED</span>
                <ChevronRight size={16} />
              </button>
            </div>

            {/* Botón hamburguesa móvil */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 rounded-md text-gray-800 hover:text-red-600 hover:bg-gray-100 transition-colors"
              aria-label="Toggle mobile menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Menú móvil */}
        <div className={`lg:hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen 
            ? 'max-h-[calc(100vh-80px)] opacity-100' 
            : 'max-h-0 opacity-0 overflow-hidden'
        }`}>
          <div className="bg-white border-t border-gray-200 shadow-lg max-h-[calc(100vh-80px)] overflow-y-auto mobile-menu-scroll">
            <div className="px-4 py-6 space-y-4">
              {/* Información de contacto móvil */}
              <div className="flex flex-col space-y-3 pb-4 border-b border-gray-200">
                <div className="flex items-center space-x-2 text-sm text-gray-600">
                  <MessageCircle size={16} />
                  <span>info@azucarmultimedia.com</span>
                </div>
                <div className="flex items-center space-x-2 text-sm text-gray-600">
                  <Phone size={16} />
                  <span>+1-408-509-0579</span>
                </div>
                <div className="flex items-center space-x-4">
                  <span className="text-sm font-bold text-gray-800">EN</span>
                  <span className="text-sm text-gray-500">ES</span>
                </div>
              </div>

              {/* Navegación móvil */}
              <nav className="space-y-2">
                <a 
                  href="#" 
                  className="block py-3 text-gray-800 font-semibold hover:text-red-600 transition-colors border-b border-gray-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  HOME
                </a>
                <a 
                  href="#" 
                  className="block py-3 text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center justify-between border-b border-gray-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <span>WHO WE HELP</span>
                  <ChevronDown size={16} />
                </a>
                <a 
                  href="#" 
                  className="block py-3 text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center justify-between border-b border-gray-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <span>PLANS</span>
                  <ChevronDown size={16} />
                </a>
                <a 
                  href="#" 
                  className="block py-3 text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center justify-between border-b border-gray-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <span>SERVICES</span>
                  <ChevronDown size={16} />
                </a>
                <a 
                  href="#" 
                  className="block py-3 text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center justify-between border-b border-gray-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <span>COMPANY</span>
                  <ChevronDown size={16} />
                </a>
                <a 
                  href="#" 
                  className="block py-3 text-gray-800 font-semibold hover:text-red-600 transition-colors border-b border-gray-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  BLOG
                </a>
                <a 
                  href="#" 
                  className="block py-3 text-gray-800 font-semibold hover:text-red-600 transition-colors flex items-center justify-between border-b border-gray-100"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <span>CONTACT</span>
                  <ChevronDown size={16} />
                </a>
              </nav>

              {/* Botones de acción móvil */}
              <div className="pt-4 space-y-3">
                <Link
                  to="/login"
                  className="block w-full text-center py-3 text-gray-800 font-medium hover:text-red-600 transition-colors border border-gray-300 rounded-md"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="block w-full text-center py-3 bg-gray-800 text-white font-medium rounded-md hover:bg-gray-700 transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Sign Up
                </Link>
                <button 
                  className="w-full bg-red-600 text-white py-3 rounded-md font-semibold hover:bg-red-700 transition-colors flex items-center justify-center space-x-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <span>GET STARTED</span>
                  <ChevronRight size={16} />
                </button>
              </div>

              {/* Redes sociales móvil */}
              <div className="flex items-center justify-center space-x-4 pt-4 border-t border-gray-200">
                <a href="#" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors p-2">
                  <Facebook size={20} />
                </a>
                <a href="#" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors p-2">
                  <Instagram size={20} />
                </a>
                <a href="#" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors p-2">
                  <Twitter size={20} />
                </a>
                <a href="#" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors p-2">
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
